import { NgModule } from '@angular/core'
import { Route, RouterModule, Routes } from '@angular/router'
import { SecuredService } from '@core/guard/secured/secured.service'
import { getRole } from '@shared/utils/degts-utils'
import { environment } from 'src/environments/environment'
import { GovbarOnlyLayoutComponent } from './layout/govbar-only-layout/govbar-only-layout.component'
import { MainLayoutComponent } from './layout/main-layout/main-layout.component'
import { DefinirSenhaService } from './modules/vinculo-supervisor/guard/definir-senha.service'

const removeSandboxInProduction = (child: Route) => !environment.production || !child?.path?.startsWith('sandbox')

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: GovbarOnlyLayoutComponent,
    children: [
      {
        path: 'cadastro',
        loadChildren: () => import('./modules/cadastro/cadastro.module').then((m) => m.CadastroModule),
      },
      {
        path: 'login',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'termos',
        loadChildren: () => import('./modules/termos-uso/termos-uso.module').then((m) => m.TermosUsoModule),
      },
      {
        path: 'senha',
        loadChildren: () =>
          import('./modules/recuperar-senha/recuperar-senha.module').then((m) => m.RecuperarSenhaModule),
      },
      {
        path: 'residentes/cadastro',
        loadChildren: () =>
          import('./modules/cadastro-residente/cadastro-residente.module').then((m) => m.CadastroResidenteModule),
      },
      {
        path: 'supervisor/vinculo/:token',
        canActivate: [DefinirSenhaService],
        loadChildren: () =>
          import('./modules/vinculo-supervisor/vinculo-supervisor.module').then((m) => m.VinculoSupervisorModule),
      },
      {
        path: 'adesao-curso',
        loadChildren: () => import('./modules/adesao-curso/adesao-curso.module').then((m) => m.AdesaoCursoModule),
      },
      {
        path: 'erro',
        loadChildren: () => import('./modules/erro/erro.module').then((m) => m.ErroModule),
      },
    ],
  },
  {
    path: '',
    /* Paths que usam o main layout com o container default */
    component: MainLayoutComponent,
    children: [
      {
        path: 'sandbox2',
        loadChildren: () => import('./modules/sandbox2/sandbox2.module').then((m) => m.Sandbox2Module),
      },
    ].filter(removeSandboxInProduction),
  },
  {
    path: '',
    /* Paths que usam o main layout sem o container default,
       então fica a critério das telas que utilizarem dessa forma de cuidar do tamanho, centralizar etc
       precisa colocar o containerDefault: false dentro de cada rota no data */
    component: MainLayoutComponent,
    children: [
      {
        path: 'dev',
        loadChildren: () => import('./modules/dev/dev.module').then((m) => m.DevModule),
      },
      {
        path: 'home',
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_DEGTS'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_FINANCEIRO'),
            getRole('ROLE_TRANSFERENCIA'),
            getRole('ROLE_RESIDENTE'),
            getRole('ROLE_DEV'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
      },
      {
        path: 'usuario',
        loadChildren: () => import('./modules/usuario/usuario.module').then((m) => m.UsuarioModule),
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_DEGTS'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_FINANCEIRO'),
            getRole('ROLE_TRANSFERENCIA'),
            getRole('ROLE_RESIDENTE'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
      },
      {
        path: 'sandbox',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_DEGTS'), getRole('ROLE_COORDENADOR')], containerDefault: false },
        loadChildren: () => import('./modules/sandbox/sandbox.module').then((m) => m.SandboxModule),
      },
      {
        path: 'avaliacoes/:programaId',
        data: { containerDefault: false },
        loadChildren: () =>
          import('./modules/avaliacao-programa/avaliacao-programa.module').then((m) => m.AvaliacaoProgramaModule),
      },
      {
        path: 'avaliacoes',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')], containerDefault: false },
        loadChildren: () =>
          import('./modules/listagem-avaliacao/listagem-avaliacao.module').then((m) => m.ListagemAvaliacaoModule),
      },
      {
        path: 'comissao',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_COORDENADOR')], containerDefault: false },
        loadChildren: () => import('./modules/comissao/comissao.module').then((m) => m.ComissaoModule),
      },
      {
        path: 'relatorios',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')], containerDefault: false },
        loadChildren: () => import('./modules/relatorio/relatorio.module').then((m) => m.RelatorioModule),
      },
      {
        path: 'programas',
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_DEGTS'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_RESIDENTE'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/programa/programa.module').then((m) => m.ProgramaModule),
      },
      // {
      //   path: 'pagamento',
      //   canActivate: [SecuredService],
      //   data: {
      //     roles: [
      //       getRole('ROLE_FINANCEIRO'),
      //       getRole('ROLE_DEGTS'),
      //       getRole('ROLE_COORDENADOR'),
      //       getRole('ROLE_SUPERVISOR'),
      //       getRole('ROLE_RESIDENTE'),
      //     ],
      //     containerDefault: false,
      //   },
      //   loadChildren: () => import('./modules/pagamento/pagamento.module').then((m) => m.PagamentoModule),
      // },
      {
        path: 'transferencia',
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_DEGTS'),
            getRole('ROLE_TRANSFERENCIA'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/transferencia/transferencia.module').then((m) => m.TransferenciaModule),
      },
      {
        path: 'residente',
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_RESIDENTE'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_DEGTS'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/residente/residente.module').then((m) => m.ResidenteModule),
      },
      {
        path: 'matricula',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_RESIDENTE')], containerDefault: false },
        loadChildren: () => import('./modules/matricula/matricula.module').then((m) => m.MatriculaModule),
      },
      {
        path: 'contestacoes',
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_RESIDENTE'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_DEGTS'),
            getRole('ROLE_ADMINISTRADOR'),
          ],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/contestacao/contestacao.module').then((m) => m.ContestacaoModule),
      },
      {
        path: 'edital',
        canActivate: [SecuredService],
        data: {
          roles: [getRole('ROLE_COORDENADOR'), getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/edital/edital.module').then((m) => m.EditalModule),
      },
      {
        path: 'configuracoes',
        canActivate: [SecuredService],
        data: { roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')], containerDefault: false },
        loadChildren: () => import('./modules/configuracoes/configuracoes.module').then((m) => m.ConfiguracoesModule),
      },
      {
        path: 'auxilio-moradia',
        canActivate: [SecuredService],
        data: {
          roles: [
            getRole('ROLE_SUPERVISOR'),
            getRole('ROLE_COORDENADOR'),
            getRole('ROLE_DEGTS'),
            getRole('ROLE_ADMINISTRADOR'),
            getRole('ROLE_RESIDENTE'),
          ],
          containerDefault: false,
        },
        loadChildren: () =>
          import('./modules/auxilio-moradia/auxilio-moradia.module').then((m) => m.AuxilioMoradiaModule),
      },
      {
        path: 'instituicao',
        canActivate: [SecuredService],
        data: {
          roles: [getRole('ROLE_DEGTS'), getRole('ROLE_ADMINISTRADOR')],
          containerDefault: false,
        },
        loadChildren: () => import('./modules/instituicao/instituicao.module').then((m) => m.InstituicaoModule),
      },
    ].filter(removeSandboxInProduction),
  },
  // {
  //   path: '',
  //   /* Paths que usam layout distintos e definidos dentro das rotas dos filhos    */
  //   children: [
  //     {
  //       path: 'pagamentosResidente',
  //       loadChildren: () =>
  //         import('./modules/pagamento-residente/pagamento-residente.module').then((m) => m.PagamentoResidenteModule),
  //     },
  //   ],
  // },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
